import { render, staticRenderFns } from "./archive-order-list.vue?vue&type=template&id=2be9f461&scoped=true"
import script from "./archive-order-list.vue?vue&type=script&lang=js"
export * from "./archive-order-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be9f461",
  null
  
)

export default component.exports